import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar";
import DOCKER_ADVANCED_SCREENSHOT from "resources/img/docker-advanced-screenshot.png";

export default React.createClass({
  displayName: "faq",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var data  = [];

    var scrollToElement = initDeepLinkData(this.props);

    return {
            data,
            navMenuParent: null,
            navMenu: null,
            scrollToElement: scrollToElement

          };
  },

  componentDidMount: function() {
    mountCode(this);
  },
  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div className="dash">
        <div className="workspace">
          <div className="workspace__container faq">
            <section id="Frequently Asked Questions">
              <div className="title">
                <Glyphicon glyph="comment" />
                <h2 id="zoom-server-troubleshooting">FaceTec Server Help & Troubleshooting</h2>
              </div>
              <p>Get help with FaceTec Server questions and issues.</p>
              <hr />
            </section>
            
            <section>
              <h3 id="initial-checks">Initial Checks</h3>
              <p>If you are having issues running FaceTec Server, here are some initial checks:</p>
              <ul>
                <li><p>Run <code>docker system prune -a</code> clears your cache, images, and containers.</p></li>
                <li><p>Check your system CPU, memory, and free hard drive space.  FaceTec requires at least 16GB of RAM for development. Disk Space requirements depend on your use case, but 20GB is the bare minimu.</p></li>
                <li><p>Check your Docker > Settings > Advanced and make sure you are allocating enough resources to your VMs:<br /><br /><img width="400" src={DOCKER_ADVANCED_SCREENSHOT} /></p></li>
              </ul>
            </section>

            <hr />

            <section>
              <h3 id="general-problems">My FaceTec Server Won't Initialize, Won't Run, Crashes, Hangs, or is doing something unexpected, and I can't figure out why.</h3>
              <p>We will be happy to assist you!  </p>
              <p>Please gather the information below,  send us a Runnable Sample (including source code), Clear Repro Steps, and gather the information below and we will be able to further assist you.</p>
              <p><Link to="/support" target="_blank">Request Support Now</Link></p>
            </section>

            <hr />

            <section>
              <h3 id="server-init-network">During Server SDK initialization, I am getting a message that 'to be able to access https://api.zoomauth.com/ so that Key validation succeeds' — How do I resolve this issue?</h3>

              <p>The FaceTec Server SDKs must have access to the internet when using Development SDK Keys in order to validate the Key.  On a system with access to the public internet, initialization will succeed without issues.  You will receive a message like the above if the Device, Host Machine, or Docker Container are unable to access http://api.zoomauth.com/.</p>

              <p>In order to resolve this issue, you will need to figure out why your Server Instance and/or Docker Container do not have proper access to the internet (more specifically, FaceTec's API) in order for initialization to succeed.</p>

              <p>Machine configurations, network configurations, firewall rules, etc., can vary and FaceTec cannot provide a precise diagnosis about why your machine cannot access the internet.  However, we do have the following troubleshooting recommendations:</p>

              <ul>
                  <li><p>If you are on a Windows Host, please check your firewall settings and ensure you are allowing outbound network traffic to the internet (more specifically https://api.zoomauth.com).</p></li>
                  <li><p>If you are on Windows, please check your firewall settings and ensure you are allowing outbound network traffic to the internet (more specifically https://api.zoomauth.com).</p></li>
                  <li><p>Attempt to <code>curl google.com</code> to see if your Host Machine or Container have general access to the internet.</p></li>
                  <li><p>Attempt to <code>curl https://api.zoomauth.com/test-connection</code> to see if your Host Machine or Container have general access to FaceTec's API.</p></li>
                  <li><p>From the Linux Host and the FaceTec Container, use <code>ip link show</code> and <code>ip addr show</code> to diagnose if Docker is attaching a network interface to your Container.</p></li>
                  <li><p>From the Linux Host and the FaceTec Container, use <code>ip link show</code> and <code>ip addr show</code> to diagnose if Docker is attaching a network interface to your Container.</p></li>
                  <li><p>If you are using Docker, run <code>docker run -ti zoomrestsdk /bin/bash</code> to access a bash terminal from the FaceTec Container itself, then attempt to curl google and the FaceTec API per the above guidance to check if the Docker Container has proper access to the internet.</p></li>
              </ul>
            </section>

            <hr />

            <section>
              <h3 id="server-troubleshooting-info">Server Troubleshooting Info</h3>
              <p>If you are having issues with FaceTec Server, the following set of information is required for us effectively assist you:</p>

              <h4 id="zoom-information">FaceTec SDK Information</h4>
              <ul>
                <li><p>What version of FaceTec Server versions are you running?</p></li>
                <li><p>Are you running the Dockerized version or the REST+Server SDK directly?</p></li>
                <li><p>What are the exact steps you are taking to reproduce the issue?</p></li>
                <li><p>Do you have any specialized code running and/or have you customized the REST Sample Code?  If yes, how have you updated it?</p></li>
                <li><p>What command are you using to run FaceTec Server?</p></li>
                <li><p>If this is on a remote server, what command are you using to deploy FaceTec Server?</p></li>
                <li><p>Are you trying to run the FaceTec Server JAR and REST Sample Code without Docker and on your own Windows/Mac machine?  Please note that FaceTec Server is a <strong>Linux JAR</strong> and does not run natively on Windows/Mac.</p></li>
              </ul>

              <h4 id="your-server-specs">Your Server Specs</h4>
              <ul>
                <li><p>Processor brand type (Intel/AMD)</p></li>
                <li><p>Exact Processor Model</p></li>
                <li><p>How much RAM does the system have?</p></li>
                <li><p>Are you using Virtualization?  What kind?  Please provide any and all details.</p></li>
                <li><p>Please send us a screenshot of the specs of your server/dev computer (whichever computer is reproducing the issue).</p></li>
                <ul>
                  <li><p>Mac - Apple Menu > About</p></li>
                  <li><p>Linux - less /proc/cpuinfo</p></li>
                  <li><p>Windows - Control Panel > System and Maintenance > System	</p></li>
                </ul>
              </ul>

              <h4 id="server-environment">Your Server Environment</h4>
              <ul>
                <li><p>Are you experiencing this while developing locally or when deployed to a remote server?</p></li>
                <li><p>Are you using a cloud provider like AWS, Google, Azure, etc.?  If so, which cloud provider and which deployment and hosting technology stack are you using?</p></li>
                <li><p>What Operating System and version are you running? Please provide the specific version?</p></li>
                <li><p>Is the server clean, or are you running other non-FaceTec services on it?</p></li>
                <li><p>If the server is clean, please provide explicit steps you took to create and configure it.</p></li>
                <li><p>If the server is not clean, can you try again on a clean server and let us know the results?</p></li>
                <li><p>Can you also provide a list of other processes running and description of the other libraries and services running on this server?</p></li>
                <li><p>If you are running on Windows, are you on a Home or Professional version?</p></li>
              </ul>

              <h4 id="reproducibility">Reproducibility</h4>
              <blockquote><p>If the answer is "No" to all of the below 3 questions, we are unlikely to be able to provide support.  If the issue is important for you to get resolved, please help us setup an environment where we can reproduce the issue ourselves.</p></blockquote>
              <ul>
                <li><p>Can you provide SSH access to the server?</p></li>
                <li><p>If not, can you create a test server that reproduces the issue and allow SSH access to us?</p></li>
                <li><p>If not, can you provide us explicit steps to set up an environment and run your scenario so that we can reproduce the issue ourselves?</p></li>
              </ul>

              <h4 id="more-bug-report-collateral">More Bug Report Collateral To Send FaceTec</h4>
              <ul>
                <li><p>A video and screenshots of the behavior.</p></li>
                <li><p>All Logs related to the problem.  Please provide <strong>all logs</strong>, not just the log line that is showing an error or warning.</p></li>
                <li><p>If you are using AWS, please export logs from CloudWatch from the affected server and send to us.</p></li>
                <li><p>For local Docker development, logs are displayed for user on screen when running <code>docker-compose up</code></p></li>
                <ul>
                  <li><p>Please either screenshot or copy and paste logs that are displayed on screen.</p></li>
                  <li><p>To export to current folder/logs.log -  <code>docker-compose logs >> logs.log</code></p></li>
                </ul>
              </ul>

              <h4 id="hang-info">Crashes and Hanging Issues</h4>
              <p>If this is a hang, please follow these steps to get us a thread dump:</p>
              <ul>
                <li><p><strong>GNU Debugger</strong></p></li>
                <ul>
                  <li><p>If 'gdb' is available, this is the easiest path to getting a thread dump.</p></li>
                  <li><p>Run the following command, replacing [PID] with your Application's process id: </p></li>
                  <ul>
                    <li><p><code>gdb -p [PID] -ex "thread apply all bt" -ex "info proc mappings" -batch</code></p></li>
                  </ul>
                </ul>
              </ul>
              <p>For both crashes and hangs, please follow these steps to get us a thread dump:</p>
              <ul>
                <ul>
                  <li><p>Core dumps are generated by the Java Runtime when certain crash conditions occur.  To enable usable crash dumps, you must set <code>ulimit -c unlimited</code> before your application runs.</p></li>
                  <li><p>Run <code>kill -11 [PID]</code> from the command line, replacing [PID] with your Application's process id.</p></li>
                  <li><p>Inspect your Application’s log output to find the details of where it has stored the core dump file.  It will be named <code>core.[PID]</code>.</p></li>
                  <li><p>The core dump file will likely be several hundred megabytes, but it will be much smaller after zipping.  Please provide us the ZIP file.</p></li>
                </ul>
              </ul>
              
            </section>

            <SDKSidebar menuType="main" title="FAQ"/>

          </div>
        </div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/js/components/screens/troubleshooting-server.jsx